export const PAGEID = 63;

export const ROUTES = {
  root: {
    path: 'domain-block',
    uri: '/domain-block',
  },
};
